import React from 'react';
import ListingTitleProps from "./props";
import style from "./style.module.scss";
import classNames from '../../../../../../../utils/classNames';

function ListingTitle(props: ListingTitleProps) {
  const ComponentAs = props.as || 'h2';
  const listingTitleClassNames = `${props.asClassName} ${classNames('listingTitle', style, props.classNames)}`;
  return (
      <ComponentAs className={listingTitleClassNames}
          {...props.dataSelector}
          {...(props['data-e2e'] && {'data-e2e': props['data-e2e']})}>
        {props.text}
      </ComponentAs>
  );
}

export default React.memo(ListingTitle);
